import { Navigate, type RouteObject } from "react-router-dom"
import Protected from "@/modules/auth/features/protected-route"
import Main from "@/layouts/main"
import Dashboard from "@/app/routes/dashboard"
import Planner from "@/app/routes/planner"
import Calendar from "@/app/routes/calendar"
import Study from "@/app/routes/study"
import Activities from "@/app/routes/activities"
import Comunications from "@/app/routes/comunications"
import MySituation from "@/app/routes/my-situation"
import Supervisor from "@/app/routes/supervisor"

const routes: RouteObject = {
  element: (
    <Protected redirect="/login" isAuth>
      <Main />
    </Protected>
  ),
  children: [
    Dashboard,
    Planner,
    Calendar,
    Study,
    Activities,
    Comunications,
    MySituation,
    Supervisor,
    {
      path: "/",
      element: <Navigate to="/planner" replace />,
    },
  ],
}

export default routes
